import { Injectable } from '@angular/core';

import { KeyValuePair } from '@reg/shared/model';

/**
 * Service used to get event approval statuses
 */
@Injectable()
export class ApprovalStatusService {
    // Consts are a copy of the ApprovalStatus enum defined in the floarena-api
    public static PENDING: string = 'pending';
    public static REVIEW: string = 'review';
    public static APPROVED: string = 'approved';
    public static DECLINED: string = 'declined';

    private types: KeyValuePair[] = [];

    /**
     * Constructor
     */
    constructor() {
        this.types.push(new KeyValuePair(ApprovalStatusService.PENDING, 'Pending'));
        this.types.push(new KeyValuePair(ApprovalStatusService.REVIEW, 'Review'));
        this.types.push(new KeyValuePair(ApprovalStatusService.APPROVED, 'Approved'));
        this.types.push(new KeyValuePair(ApprovalStatusService.DECLINED, 'Declined'));
    }

    /**
     * Get all approval statuses
     */
    public getIndex(): KeyValuePair[] {
        return this.types;
    }

    /**
     * Get a single approval status
     */
    public get(key: string): KeyValuePair {
        const foundTypes: KeyValuePair[] = this.types.filter((type: KeyValuePair) => type.key === key);

        if (foundTypes && foundTypes.length > 0) {
            // Found a match
            return foundTypes[0];
        }

        // No match found so construct a new one
        return new KeyValuePair(key, key);
    }
}
